/* unplugin-vue-components disabled */import script from "./NotificationList.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationList.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationList.vue?vue&type=style&index=0&id=1f5b2c56&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f5b2c56"]])

export default __exports__